const state = {
    // !全局设定loading
    load: true,
    
    // 参数
    params: {},

    // !页面宽度
    clientWidth: document.documentElement.clientWidth,
    scrollTop: document.documentElement.scrollTop,

    banner: {},

    userInfo: {},

    islogin: null,

    activeIndex: 0
}

export default state